import { FileExtentionTypes } from "@presentation/FormBuilder/FileTypeExtensionInterface";
import {
  IFileUploadFieldConfigurationClient,
  IFileUploadFieldConfigurationServer,
} from "./interface";

export const transformFileUploadFieldConfigClientToServer = (
  fieldConfigClient: IFileUploadFieldConfigurationClient
): IFileUploadFieldConfigurationServer => {
  const { isSpecificFileType, selectedFileTypes, maxNumFiles, maxFileSize, isImageViewEnable, isLogoUpload, imageHeight, imageWidth } =
    fieldConfigClient;
  const selectedFileTypesServer: string[] = [];
  selectedFileTypes?.forEach((selectedFileType: FileExtentionTypes) => {
    selectedFileTypesServer?.push(selectedFileType);
  });
  const selected = selectedFileTypesServer?.length > 0;
  const isSelctedTypeData = isSpecificFileType ? isSpecificFileType : selected;
  const fieldConfigServer = {
    allowedFileTypes:
      (isSelctedTypeData && { multiSelected: selectedFileTypesServer }) || {},
    maxNumFiles: maxNumFiles,
    maxFileSize: maxFileSize,
    imageHeight: imageHeight,
    imageWidth: imageWidth,
    isImageViewEnable: isImageViewEnable,
    isLogoUpload: isLogoUpload,
  };
  return fieldConfigServer;
};

export const transformFileUploadConfigServerToClient = (
  fieldConfigServer: IFileUploadFieldConfigurationServer
): IFileUploadFieldConfigurationClient => {
  const { allowedFileTypes, maxNumFiles, maxFileSize, isImageViewEnable, isLogoUpload, imageHeight, imageWidth } = fieldConfigServer;

  const selectedUploadFileTypesClient: FileExtentionTypes[] = [];
  allowedFileTypes?.multiSelected?.forEach(
    (selectedUploadFileTypeServer: FileExtentionTypes) => {
      selectedUploadFileTypesClient?.push(selectedUploadFileTypeServer);
    }
  );

  const isSpecificFileType = Array.isArray(selectedUploadFileTypesClient) && selectedUploadFileTypesClient.length > 0;
  const fieldConfigClient = {
    selectedFileTypes: selectedUploadFileTypesClient,
    maxNumFiles: maxNumFiles,
    maxFileSize: maxFileSize,
    imageHeight: imageHeight,
    imageWidth: imageWidth,
    isSpecificFileType: isSpecificFileType,
    isImageViewEnable: isImageViewEnable,
    isLogoUpload: isLogoUpload,
  };
  return fieldConfigClient;
};
